(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/use-formatted-date-time.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/use-formatted-date-time.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;

const useFormattedDateTime = _ref => {
  let startTime = _ref.startTime,
    registrationEndTime = _ref.registrationEndTime,
    isLateReg = _ref.isLateReg;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dateLabel = _useState2[0],
    setDateLabel = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    timeLabel = _useState4[0],
    setTimeLabel = _useState4[1];
  useEffect(() => {
    let interval;
    if (isLateReg) {
      setDateLabel('Sen reg');
      const minutesLeft = dateFns.differenceInMinutes(new Date(registrationEndTime), new Date());
      setTimeLabel("".concat(minutesLeft, " min"));
      interval = setInterval(() => {
        const minutesLeft = dateFns.differenceInMinutes(new Date(registrationEndTime), new Date());
        if (minutesLeft > 0) {
          setTimeLabel("".concat(minutesLeft, " min"));
        } else {
          setTimeLabel('Startar nu');
        }
      }, 1000);
    } else {
      const minutesLeft = dateFns.differenceInMinutes(new Date(startTime), new Date());
      if (minutesLeft < 60) {
        setDateLabel('Startar om');
        setTimeLabel("".concat(minutesLeft, " min"));
        interval = setInterval(() => {
          const minutesLeft = dateFns.differenceInMinutes(new Date(startTime), new Date());
          if (minutesLeft > 0) {
            setTimeLabel("".concat(minutesLeft, " min"));
          } else {
            setDateLabel('Startar');
            setTimeLabel('nu');
          }
        }, 1000);
      } else {
        setDateLabel(formatDate(new Date(startTime), false, true, true, true));
        setTimeLabel(dateFns.format(new Date(startTime), 'HH:mm'));
      }
    }
    return () => clearInterval(interval);
  }, [startTime, registrationEndTime, isLateReg]);
  return {
    dateLabel,
    timeLabel
  };
};
setGlobal('svs.poker_react.components.upcomingEvents.useFormattedDateTime', useFormattedDateTime);

 })(window);